import gql from 'graphql-tag';

export class MenuQuery {
  public static MENU_TYPE_QUERY = gql`
  query{
    obtenerMenus {
      menu {
        rolId
        menuId
        rolDescripcion
        menuDescripcion
        rolCodigo
        menuCodigo
        orden
        subMenuList {
          rolId
          menuId
          rolDescripcion
          menuDescripcion
          rolCodigo
          menuCodigo
          orden
        }
        botonList {
          id
          codigo
          descripcion
        }
      }
      footer {
        rolId
        menuId
        rolDescripcion
        menuDescripcion
        rolCodigo
        menuCodigo
        orden
        subMenuList {
          rolId
          menuId
          rolDescripcion
          menuDescripcion
          rolCodigo
          menuCodigo
          orden
        }
        botonList {
          id
          codigo
          descripcion
        }
      }
      status
      codigoRespuesta
      errorMessage
      mensaje
    }
  }`

  public static OBTENER_ROLES_POR_MENU_TYPE_QUERY = gql`
    query OBTENER_ROLES_POR_MENU_TYPE_QUERY(
      $aplicacionId: Int,
      $hash: String
    ){
      obtenerMenusPorRolUsuario(input: {
          aplicacionId: $aplicacionId,
          hash: $hash
      }){
        listaRolMenu {
          rolId
          menuId
          rolDescripcion
          menuDescripcion
          rolCodigo
          menuCodigo
          aplicacionId
        }
        status
        codigoRespuesta
        errorMessage
        mensaje
      }
    }`
}
